import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import styles from './Common.module.css';
import { AlSection, AlPhysPerfTestRow } from 'PatientCareCenter/Note/AL';


class AlPhysPerfTest extends React.Component {

    add() {
        this.props.addAlRow(this.props.noteId, 'MLSPECIALTYTESTS', 'XLSZ', 'XLSZNO', 'XLSZXLNO', this.props.xlno, 'NEW_XLSZNO', (this.props.trackAssist && !this.props.isLicensed));
    }

    render() {
        return (
            <AlSection
                id='al_physperftest'
                name='Physical Performance Test or Measurement'
                timeRequired={false}
                timeVisible={false}
                onAdd={() => this.add()}
                className={this.props.className}
            >
                {this.props.tests.length > 0 &&
                    <div className={styles.row}>
                        <span className={styles.button_spacer} />
                        <span className={styles.col1_header}>Activity</span>
                        <span className={styles.col2_wide_header}>Description</span>
                        <span className={styles.col3_narrow_header}>Time</span>
                        <span className={styles.col4_header}>Performed</span>
                    </div>
                }
                {Object.keys(this.props.tests)
                    .map(key => {
                        const result = this.props.tests[key];
                        return (
                            <AlPhysPerfTestRow key={result.XLSZNO} id={result.XLSZNO} />
                        )
                    })
                }
            </AlSection>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        addAlRow: bindActionCreators(noteActions.addAlRow, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let trackAssist = state.entities.admissions[epno].contractTracksAssistant;
    let isLicensed = state.entities.authentication.user.islicensed;

    return {
        noteId,
        xlno,
        tests: Object.keys(state.entities.notes.MLSPECIALTYTESTS)
            .filter(key => {
                return (state.entities.notes.MLSPECIALTYTESTS[key].XLSZXLNO === xlno)
            })
            .sort((a, b) => state.entities.notes.MLSPECIALTYTESTS[a].XLSZNO - state.entities.notes.MLSPECIALTYTESTS[b].XLSZNO)
            .map(key => state.entities.notes.MLSPECIALTYTESTS[key]),
        trackAssist,
        isLicensed,
    };
}

const connectedAlPhysPerfTest = connect(mapStateToProps, mapDispatchToProps)(AlPhysPerfTest);
export { connectedAlPhysPerfTest as AlPhysPerfTest };

